var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-table',{attrs:{"header":_vm.header,"list":_vm.list,"item-key":"name","searchWord":_vm.searchString},on:{"update:list":function($event){_vm.list=$event},"update:searchWord":function($event){_vm.searchString=$event},"update:search-word":function($event){_vm.searchString=$event},"clickRow":_vm.clickRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }